function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("title", null, "menu-icon");

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  fill: "#99c24d",
  width: 45.41,
  height: 40.22,
  rx: 3.64
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M36.42,12.11a1.15,1.15,0,0,1-1.15,1.14H10.14A1.15,1.15,0,0,1,9,12.11V9.83a1.16,1.16,0,0,1,1.15-1.15H35.27a1.16,1.16,0,0,1,1.15,1.15Zm0,9.14a1.16,1.16,0,0,1-1.15,1.15H10.14A1.16,1.16,0,0,1,9,21.25V19a1.16,1.16,0,0,1,1.15-1.15H35.27A1.16,1.16,0,0,1,36.42,19Zm0,9.14a1.16,1.16,0,0,1-1.15,1.15H10.14A1.16,1.16,0,0,1,9,30.39V28.11A1.15,1.15,0,0,1,10.14,27H35.27a1.15,1.15,0,0,1,1.15,1.14Z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45.41,
    height: 40.22,
    viewBox: "0 0 45.41 40.22"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/menu-icon.91b47b2d.svg";
export { SvgComponent as ReactComponent };